import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('expose_channels_on_va_conversation_history');
	},
};
